import Markdown from "../../../../../../packages/design-system/src/Markdown/index.tsx";
import * as React from 'react';
export default {
  Markdown,
  React
};